import axios from 'axios';
import config from '../config'

const instance = axios.create({ baseURL: config.NODE_ENV==='development' ? config.CASINO_DEV_API : config.CASINO_API });

export default instance;